import { Box, Card, Flex, Text, Button } from "@radix-ui/themes";
import { AlertTriangle } from "lucide-react";

interface ErrorCardProps {
  error?: string;
}

const ErrorCard = ({ error }: ErrorCardProps) => {
  return (
    <Box p="4">
      <Card>
        <Box p="6">
          <Flex direction="column" align="center" gap="4">
            <Box>
              <AlertTriangle size={48} style={{ color: "var(--amber-9)" }} />
            </Box>

            <Text size="6" weight="bold" align="center">
              Error Loading Data
            </Text>

            <Text size="3" color="gray" align="center">
              There was a problem loading this resource.
            </Text>

            <Box
              style={{
                backgroundColor: "var(--gray-2)",
                borderRadius: "var(--radius-2)",
                padding: "0.5rem",
                maxWidth: "24rem",
                overflowX: "auto",
              }}
            >
              <Text size="2" color="gray">
                {error || "Unknown error"}
              </Text>
            </Box>

            <Button
              variant="soft"
              color="gray"
              onClick={() => window.history.back()}
            >
              Go Back
            </Button>
          </Flex>
        </Box>
      </Card>
    </Box>
  );
};

export default ErrorCard;
